import PropTypes from 'prop-types';
import React from 'react';
import {
  Table,
  TableHeader,
  TableBody,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from '@unite-us/app-components';
import moment from 'moment';
import TableRowLoading from 'common/display/Table/TableRowLoading';
import ReferralRowIcon from 'src/components/Dashboard/components/Referrals/ReferralRowIcon';
import { get, isEmpty, map } from 'lodash';
import { referralStatuses } from '../utils/referralStatusConstants';
import '../stylesheets/ReferralHistoryTable.scss';

const ReferralHistoryTable = ({
  referrals,
  isFetchingReferrals,
  isClosedByCoordinationCenter,
}) => {
  const NoReferralsView = () => (
    <TableRow
      hoverable={false}
      clickable={false}
    >
      <div className="no-referrals">
        <p className="no-content">
          No referrals
        </p>
      </div>
    </TableRow>
  );

  const data = isEmpty(referrals) ? NoReferralsView() : (
    map(referrals, (referralObj, index) => {
      const isFirstReferralClosedByCoordinationCenter = isClosedByCoordinationCenter && index === 0;

      return (
        <TableRow
          key={`table-row-${referralObj.id}`}
          hoverable={false}
          clickable={false}
          onCellClick={() => {}}
        >
          <TableRowColumn className="is-grouped">
            <ReferralRowIcon referral={referralObj} />
          </TableRowColumn>
          <TableRowColumn>
            {get(referralObj, 'sending_provider.name')}
          </TableRowColumn>
          <TableRowColumn>
            {get(referralObj, 'receiving_provider.name')}
          </TableRowColumn>
          <TableRowColumn>
            {referralObj.state !== 'draft' ? moment.unix(get(referralObj, 'created_at')).format('MMMM DD, YYYY') : ''}
          </TableRowColumn>
          <TableRowColumn>
            {isFirstReferralClosedByCoordinationCenter ?
              referralStatuses.reviewed({ showText: true }) :
              referralStatuses[referralObj.state]({ showText: true })}
          </TableRowColumn>
        </TableRow>
      );
    })
  );

  return (
    <Table
      noBorder
      className="overflow-visible"
    >
      <TableHeader className="referral-history-header">
        <TableRow>
          <TableHeaderColumn />
          <TableHeaderColumn>
            Sender
          </TableHeaderColumn>
          <TableHeaderColumn>
            Recipient
          </TableHeaderColumn>
          <TableHeaderColumn>
            Sent Date
          </TableHeaderColumn>
          <TableHeaderColumn>
            Status
          </TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody>
        {isFetchingReferrals ? <TableRowLoading /> : data}
      </TableBody>
    </Table>
  );
};

ReferralHistoryTable.propTypes = {
  referrals: PropTypes.array,
  isFetchingReferrals: PropTypes.bool,
  isClosedByCoordinationCenter: PropTypes.bool.isRequired,
};
ReferralHistoryTable.defaultProps = {
  referrals: [],
  isFetchingReferrals: false,
};

export default ReferralHistoryTable;
